module.exports = __webpack_public_path__ + "static/boldare_products-c78b8a0c7a2575f0fb14598c576e8d06.mp4";